import { ELCLogger, TriggerType } from '@estee/elc-logging';
export class PerformanceMarker {
    private readonly logger: ELCLogger;
    private readonly serviceViewName: string;

    constructor(logger: ELCLogger, name: string) {
        this.logger = logger;
        this.serviceViewName = name;
    }

    startMark = (name: string) => {
        try {
            performance.mark(`${this.serviceViewName}_${name}`);
        } catch (error) {
            this.logger.error({
                message: `[${this.serviceViewName}]: ${error}`,
                triggerType: TriggerType.other,
                payload: {
                    error
                }
            });
        }
    };

    endMark = (name: string) => {
        try {
            if (performance.getEntriesByName(name)) {
                const markName = `${this.serviceViewName}_${name}`;
                const markNameEnd = `${markName}_end`;

                performance.mark(markNameEnd);

                const measurement = performance.measure(
                    `${this.serviceViewName}_measure_${name}`,
                    markName,
                    markNameEnd
                ) as unknown as PerformanceMeasure;
                this.logger.info({
                    triggerType: TriggerType.other,
                    message: `Performance measure between (${markName}) and (${markNameEnd})`,
                    payload: {
                        context: measurement.toJSON(),
                        serviceName: this.serviceViewName
                    }
                });
                this.clearMark(markName);

                return measurement;
            }
        } catch (error) {
            this.logger.error({
                message: `[${this.serviceViewName}]: ${error}`,
                triggerType: TriggerType.other,
                payload: {
                    error
                }
            });
        }
    };

    // Chrome has a limit of markers that it can support at the same time
    // In order to limit the amount of markers we'll clean everything except the measure one after we take the measurements
    clearMark = (name: string) => {
        performance.clearMarks(name);
        performance.clearMarks(`${name}_end`);
    };
}
